(() => {
  'use strict';
  const fetchCart = (...args) => window.fetch(...args);
  const root = () => window.Shopify?.routes?.root || '/';
  const $ = (s, q) => s.querySelector(q);
  const $$ = (s, q) => [...s.querySelectorAll(q)];
  const eligibleIds = new Set(['54400408879431','54400408912199']);
  const stateKey = 'vb-trio-unlocked-v2';
  let unlocked = false;
  try { unlocked = sessionStorage.getItem(stateKey) === 'yes'; } catch {}
  let serial = Promise.resolve();
  async function request(path, body) {
    const response = await fetchCart(root() + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? {body: JSON.stringify(body)} : {})
    });
    const cart = await response.json();
    if (!response.ok || cart.status >= 400) throw new Error(cart.description || 'Le panier n’a pas pu être mis à jour.');
    return cart;
  }
  function config() { return document.querySelector('[data-vb-welcome]'); }
  function managed(item) { return item.properties?._vb_welcome === 'trio'; }
  function hasPack(cart) { return cart.items.some(i => eligibleIds.has(String(i.variant_id)) && i.quantity > 0); }
  async function cleanup(cart) {
    cart = cart || await request('cart.js');
    const qualified = hasPack(cart);
    const changes = {};
    cart.items.filter(managed).forEach(item => {
      if (!qualified || item.final_line_price > 0) changes[item.key] = 0;
      else if (item.quantity > 1) changes[item.key] = 1;
    });
    if (Object.keys(changes).length) return request('cart/update.js', {updates:changes});
    return cart;
  }
  function enqueue(work) {
    const next = serial.then(work, work);
    serial = next.catch(() => {});
    return next;
  }
  async function applyGift(cart) {
    const section = config();
    if (!unlocked || !section?.dataset.code) return cleanup(cart);
    let before = await cleanup(cart);
    if (!hasPack(before)) return before;
    if (before.items.some(managed)) return before;
    const variant = Number(section.dataset.giftVariant);
    const quantity = Number(section.dataset.giftQuantity);
    if (!Number.isSafeInteger(variant) || variant < 1 || quantity !== 1) throw new Error('La référence du trio doit être vérifiée.');
    const attempt = Date.now().toString(36);
    try {
      await request('cart/add.js', {items:[{id:variant,quantity,properties:{_vb_welcome:'trio',_vb_attempt:attempt,'Cadeau':'Trio de bienvenue · 3 masques visage'}}]});
      const codes = [...new Set([...(before.discount_codes || []).map(d=>d.code), section.dataset.code])];
      const updated = await request('cart/update.js', {discount:codes.join(',')});
      const gift = updated.items.find(i=>i.properties?._vb_attempt===attempt);
      if(window.vbBundles?.enabled) window.vbBundles.verifyCart(updated);
      if (!gift || gift.final_line_price !== 0) throw new Error('Le code cadeau n’est pas disponible pour ce panier. Aucun masque payant n’a été conservé.');
      return updated;
    } catch (error) {
      const now = await request('cart.js');
      const additions = now.items.filter(i=>i.properties?._vb_attempt===attempt);
      if (additions.length) await request('cart/update.js',{updates:Object.fromEntries(additions.map(i=>[i.key,0]))});
      await request('cart/update.js',{discount:(before.discount_codes||[]).map(d=>d.code).join(',')});
      throw error;
    }
  }
  window.vbWelcome = { syncCart:cart=>enqueue(()=>applyGift(cart)), cleanup:cart=>enqueue(()=>cleanup(cart)) };
  document.addEventListener('vb:cart-changed', event => {
    const work = enqueue(()=>cleanup(event.detail?.cart));
    if (event.detail?.waitUntil) event.detail.waitUntil(work);
    else work.catch(()=>{});
  });
  function init(section) {
    if (section.dataset.welcomeReady) return;
    section.dataset.welcomeReady='true';
    const dialog=$(section,'dialog'), status=$(section,'[data-vb-gift-status]');
    const form=$(section,'.vb-gift-email form');
    let opener, animation, animating=false, counted=false;
    const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
    function panel(name) {
      $$(section,'[data-vb-panel]').forEach(p=>p.hidden=p.dataset.vbPanel!==name);
      const heading=$(section,'[data-vb-panel="'+name+'"] h2');
      if(heading){heading.id='vb-gift-heading-'+name+'-'+section.id;dialog.setAttribute('aria-labelledby',heading.id);}
      if (dialog.open) heading?.focus({preventScroll:true});
      dialog.scrollTop=0;
    }
    function close() {
      if(animation){animation.cancel();animation=null;animating=false;$(section,'[data-vb-play]').disabled=false;}
      dialog.close();document.documentElement.classList.remove('vb-gift-lock');
      if(opener?.isConnected)opener.focus({preventScroll:true});
    }
    function revealCode() {
      $(section,'[data-vb-code-panel]').hidden=false;
      $(section,'[data-vb-code-text]').textContent=section.dataset.code;
      $(section,'.vb-gift-email').hidden=true;
    }
    section._vbOpen=button=>{
      opener=button;
      if (unlocked){panel('result');revealCode();}
      dialog.showModal();document.documentElement.classList.add('vb-gift-lock');
      const current=$$(section,'[data-vb-panel]').find(p=>!p.hidden);if(current)panel(current.dataset.vbPanel);
    };
    $(section,'[data-vb-close-gift]').addEventListener('click',close);
    dialog.addEventListener('cancel',e=>{e.preventDefault();close();});
    dialog.addEventListener('click',e=>{
      if(e.target!==dialog)return;
      const r=dialog.getBoundingClientRect();
      if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();
    });
    $$(section,'[data-vb-quiz-choice]').forEach(b=>b.addEventListener('click',()=>{
      $(section,'[data-vb-answer]').textContent=b.dataset.answer;panel('game');
      const endpoint=section.dataset.analyticsEndpoint;
      if(!counted && endpoint && ['cheeks','makeup','comfort','discovery'].includes(b.dataset.motivation)){
        try{
          const url=new URL(endpoint);
          if(url.protocol==='https:'){
            counted=true;
            fetchCart(url.href,{method:'POST',credentials:'omit',referrerPolicy:'no-referrer',headers:{'Content-Type':'application/json'},body:JSON.stringify({version:1,answer:b.dataset.motivation}),keepalive:true}).catch(()=>{});
          }
        }catch{}
      }
    }));
    $(section,'[data-vb-skip-quiz]').addEventListener('click',()=>panel('game'));
    // A fixed-step gravity/collision simulation; every pocket reveals the same welcome gift.
    function plinkoFrames(seed=Math.random()) {
      const pins=[];
      for(let row=0;row<7;row++)for(let col=0;col<7;col++)pins.push({x:25+col*38+(row%2)*19,y:47+row*27});
      const dt=1/120,frames=[];let x=145+seed*10,y=14,vx=(seed-.5)*22,vy=0;
      for(let tick=0;tick<840;tick++){
        vy+=800*dt;x+=vx*dt;y+=vy*dt;
        if(x<10){x=10;vx=Math.abs(vx)*.7;}if(x>290){x=290;vx=-Math.abs(vx)*.7;}
        for(const pin of pins){
          const dx=x-pin.x,dy=y-pin.y,d=Math.hypot(dx,dy),r=12;
          if(d<r){
            const nx=d>0?dx/d:.1,ny=d>0?dy/d:-1;
            x=pin.x+nx*r;y=pin.y+ny*r;
            const speed=vx*nx+vy*ny;
            if(speed<0){vx-=1.48*speed*nx;vy-=1.48*speed*ny;}
            if(Math.abs(vx)<9)vx=(dx>=0?1:-1)*18;
          }
        }
        if(tick%3===0)frames.push({left:(x/3)+'%',top:(y/2.7)+'%'});
        if(y>=246){frames.push({left:(x/3)+'%',top:'91.1%'});return {frames,duration:(tick+1)*dt*1000};}
      }
      return {frames,duration:7000};
    }
    $(section,'[data-vb-play]').addEventListener('click',async e=>{
      if(animating)return;animating=true;const button=e.currentTarget;button.disabled=true;
      const ball=$(section,'.vb-plinko-ball-v2');
      try{
        if(!reduced() && ball.animate){
          const path=plinkoFrames();
          animation=ball.animate(path.frames,{duration:path.duration,easing:'linear',fill:'forwards'});
          await animation.finished;
          animation.cancel();animation=null;
        }
        panel(unlocked?'result':'email');
      }catch(error){if(error.name!=='AbortError')panel(unlocked?'result':'email');}
      finally{animating=false;button.disabled=false;}
    });
    form.addEventListener('submit',()=>{
      try{sessionStorage.setItem('vb-gift-email-origin',form.id);}catch{}
    });
    const success=$(form,'[data-vb-email-success]'), error=$(form,'[data-vb-email-error]');
    if(success){
      unlocked=true;try{sessionStorage.setItem(stateKey,'yes');sessionStorage.removeItem('vb-gift-email-origin');}catch{}
      revealCode();panel('result');section._vbOpen(document.querySelector('[data-vb-open-gift]'));
    } else if(error){
      panel('email');section._vbOpen(document.querySelector('[data-vb-open-gift]'));error.focus();
    }
    $(section,'[data-vb-copy-code]').addEventListener('click',async e=>{
      if(!unlocked)return;
      const b=e.currentTarget;
      try {
        await navigator.clipboard.writeText(section.dataset.code);
        b.textContent=b.dataset.copiedLabel;
      } catch {
        const range=document.createRange();range.selectNodeContents($(section,'[data-vb-code-text]'));
        const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);
        status.textContent='Sélectionne puis copie ton code.';
      }
    });
    $(section,'[data-vb-claim]').addEventListener('click',async e=>{
      if(!unlocked||animating)return;
      const b=e.currentTarget, choice=document.querySelector('[data-vb-variant]:checked');
      animating=true;b.disabled=true;
      try {
      const before=await request('cart.js').catch(()=>null);
      if(!before){status.textContent='Le panier est indisponible. Réessaie dans un instant.';return;}
      if(!hasPack(before)&&(!choice||!eligibleIds.has(choice.dataset.vbVariant))){
        status.textContent='Choisis un lot de 4 ou 6 sticks pour ajouter ton trio.';
        close();document.querySelector('#vb-offers')?.scrollIntoView({behavior:reduced()?'instant':'smooth',block:'center'});
        const productStatus=document.querySelector('[data-vb-status]');
        if(productStatus)productStatus.textContent='Ton code est prêt. Choisis 4 ou 6 sticks pour recevoir ton trio offert.';
        return;
      }
      status.textContent='Ajout de ton cadeau…';
        if(!hasPack(before)) {
          if(window.vbBundles?.enabled) await window.vbBundles.add(choice);
          else await request('cart/add.js',{items:[{id:Number(choice.dataset.vbVariant),quantity:1,properties:window.vbPackProperties?.(choice)||{}}]});
        }
        await enqueue(()=>applyGift());
        close();
        if(window.vbCart)await window.vbCart.open(opener);
        else location.assign(root()+'cart');
      } catch(error){status.textContent=error.message;}
      finally{animating=false;b.disabled=false;}
    });
    section._vbDestroy=()=>{animation?.cancel();if(dialog.open)close();};
  }
  function boot(scope=document){$$(scope,'[data-vb-welcome]').forEach(init);}
  document.addEventListener('click',e=>{
    const b=e.target.closest('[data-vb-open-gift]');if(!b)return;
    (b.closest('[data-vb-welcome]')||config())?._vbOpen?.(b);
  });
  document.addEventListener('shopify:section:load',e=>boot(e.target));
  document.addEventListener('shopify:section:unload',e=>$$(e.target,'[data-vb-welcome]').forEach(s=>s._vbDestroy?.()));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
})();
